/**
 * Units of every recorded duration column the admin reads, anchored on the code that
 * writes each one (origin/next 2026-09-17) and on the live column type (db2 information_schema,
 * 2026-09-17: all three `integer`). No reader may assume a unit that is not in this table.
 */
export const DURATION_COLUMN_TABLE = Object.freeze({
  'agent_logs.duration': {
    unit: 'ms',
    source: 'routes/agents-test.js:147 duration: processingTime = Date.now() - startTime; agents/keyword-extractor-agent/src/index.ts:255 duration: Date.now() - startTime; agents/competitive-analysis-agent/src/services/logger.ts:96 duration: processingTimeMs; agents/page-chatbot-agent/src/services/dualLogger.ts:197 "duration, // duration_ms"; agents/{adjacent-topics,customer-intent,narrative-presentation,question-suggestion}-agent/src/types.ts "execution time in ms"; db2 rows topic-research 8,010-12,151, adjacent-topics 522-540',
  },
  'agent_logs.duration_ms': {
    unit: 'ms',
    source: 'routes/logs-postgresql.js:337-364 PUT /api/logs/:traceId body duration_ms; agents/page-semantic-intent-agent/src/config/postgres-db.ts:150 doc.duration_ms',
  },
  'agent_test_runs.processing_time_ms': {
    unit: 'ms',
    source: 'routes/agents-test.js:117-134 processing_time_ms: processingTime = Date.now() - startTime; migrations declare INTEGER at 11 sites, none NUMERIC',
  },
} as const);

/**
 * Duration of an agent execution as the row recorded it. Readers see only
 * `duration_ms` (normalizeAgentLogRow folds every column in the table into it);
 * mapToExecutionLog divides it by 1000 into ExecutionLog.duration seconds. Nothing
 * recorded: say so, never a number.
 */
export function formatAgentLogDuration(l: object | null | undefined): string {
  const ms = l ? (l as { duration_ms?: unknown }).duration_ms : undefined;
  return typeof ms === 'number' ? `${ms}ms` : 'not recorded';
}
